/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PatchedViewSettings
 */
export interface PatchedViewSettings {
  /**
   *
   * @type {number}
   * @memberof PatchedViewSettings
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedViewSettings
   */
  tableName?: string;
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof PatchedViewSettings
   */
  columnSettings?: { [key: string]: boolean };
  /**
   *
   * @type {string}
   * @memberof PatchedViewSettings
   */
  urlParameters?: string | null;
}

/**
 * Check if a given object implements the PatchedViewSettings interface.
 */
export function instanceOfPatchedViewSettings(value: object): value is PatchedViewSettings {
  return true;
}

export function PatchedViewSettingsFromJSON(json: any): PatchedViewSettings {
  return PatchedViewSettingsFromJSONTyped(json, false);
}

export function PatchedViewSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedViewSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    tableName: json['table_name'] == null ? undefined : json['table_name'],
    columnSettings: json['column_settings'] == null ? undefined : json['column_settings'],
    urlParameters: json['url_parameters'] == null ? undefined : json['url_parameters'],
  };
}

export function PatchedViewSettingsToJSON(value?: Omit<PatchedViewSettings, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    table_name: value['tableName'],
    column_settings: value['columnSettings'],
    url_parameters: value['urlParameters'],
  };
}
